import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { PlanForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { planData, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Plans", link: "/plan" },
                { name: "Edit", link: "" },
                { name: planData?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Plan" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Plan Update"}
                        bordered={true}
                    >
                        {planData && (
                            <PlanForm
                                plan={planData}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
